export default __webpack_public_path__ + "ec3b0307f7fd8dc16d073c8ffa2e05b3.svg";